import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export const ApplicationNextAction = gql`
  fragment ApplicationNextAction on PollChargeCardApplicationSuccess {
    id
    nextAction
    cardId
  }
`;

const GetChargeCardApplication = gql`
  query GetCCApplicationState($id: ID!) {
    pollChargeCardApplicationStatus(id: $id) {
      ...ApplicationNextAction
      ...error
    }
  }
  ${ApplicationNextAction}
  ${error}
`;

export default GetChargeCardApplication;
